"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var antd_1 = require("antd");
Object.defineProperty(exports, "Badge", { enumerable: true, get: function () { return antd_1.Badge; } });
